import { last } from "lodash";
import { useEffect, useState } from "react";
import { getColorFromInitial } from "../../utils/Utils";
import { UserDetailModal } from "./UserDetailModal";
import { useImageLoader } from "../customHook/ImageLoader";
import { Avatar, Image, Spin } from "antd";
import { OnlineCircle } from "./OnlineCircle";

const CustomAvatar = ({
  conversationAvatar,
  person,
  size = 40,
  index,
  pos,
  styleCss = { position: "absolute" },
  isShowDetail = false,
  isShowUserStatus = { status: false, isAlwaysTrue: false },
  userId,
}) => {
  const [briefName, setBriefName] = useState();
  const [isOpenModalUserDetail, setIsOpenModalUserDetail] = useState(false);
  const [isPreview, setIsPreview] = useState(false);

  const {
    imageUrl,
    loading: isImageLoading,
    error: imageError,
  } = useImageLoader(conversationAvatar ?? person?.avatar);

  const handleOpenModalUserDetail = () => {
    if (!isShowDetail) return;

    setIsOpenModalUserDetail(true);
  };

  useEffect(() => {
    setBriefName(
      last(person?.name?.trim()?.split(" "))?.[0] ||
        last(person?.username?.trim()?.split(" "))?.[0] ||
        "",
    );
  }, [person]);

  if (conversationAvatar) {
    if (imageError) {
      return (
        <Avatar
          size={size}
          style={{
            backgroundColor: getColorFromInitial(briefName),
          }}
        >
          {briefName}
        </Avatar>
      );
    }

    return (
      <>
        <Avatar
          src={imageUrl}
          size={size}
          style={{
            backgroundColor: "#D3E3FD",
          }}
          onClick={() => setIsPreview(true)}
        >
          {briefName}
        </Avatar>
        {isPreview && (
          <Image
            wrapperStyle={{
              display: "none",
            }}
            preview={{
              visible: isPreview,
              onVisibleChange: (visible) => setIsPreview(visible),
            }}
            src={imageUrl}
          />
        )}
      </>
    );
  }

  if (pos === -1) {
    if (imageError) {
      return (
        <div className={`relative`}>
          <Avatar
            style={{
              backgroundColor: getColorFromInitial(briefName),
            }}
            size={size}
          >
            {briefName}
          </Avatar>
          {(isShowUserStatus.status || isShowUserStatus.isAlwaysTrue) && (
            <OnlineCircle userId={userId} size={"small"} />
          )}
        </div>
      );
    }

    if (isImageLoading) {
      return (
        <div className={`relative`}>
          <Avatar
            style={{
              backgroundColor: getColorFromInitial(briefName),
            }}
            size={size}
            icon={<Spin />}
          >
            {briefName}
          </Avatar>
          {(isShowUserStatus.status || isShowUserStatus.isAlwaysTrue) && (
            <OnlineCircle userId={userId} size={"big"} />
          )}
        </div>
      );
    }
  }

  return (
    <>
      <div className={`relative`}>
        <Avatar
          style={{
            ...pos,
            zIndex: 10 - index,
            width: size,
            height: size,
            borderRadius: "50%",
            backgroundColor: getColorFromInitial(briefName),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 12,
            color: "#fff",
            fontWeight: 500,
            userSelect: "none",
            ...styleCss,
          }}
          size={size}
          src={imageUrl}
          className={`${isShowDetail ? "cursor-pointer" : ""}`}
          onClick={handleOpenModalUserDetail}
        >
          {briefName}
        </Avatar>

        {(isShowUserStatus.status || isShowUserStatus.isAlwaysTrue) && (
          <OnlineCircle userId={userId} size={"small"} />
        )}
      </div>
      {isOpenModalUserDetail && (
        <UserDetailModal
          person={person}
          isOpen={isOpenModalUserDetail}
          handleCancel={() => setIsOpenModalUserDetail(false)}
        />
      )}
    </>
  );
};
export { CustomAvatar };
